<template>
    <AppHeader />
  
    <div class="container mx-auto p-4">
      <div class="max-w-4xl mx-auto bg-white dark:bg-slate-800 rounded-lg shadow-md overflow-hidden">
        <div class="p-4 border-b dark:border-slate-700 flex items-center justify-between">
          <h2 class="text-lg font-semibold text-gray-900 dark:text-gray-100">Gerenciar Entregas por Unidade</h2>
          <span class="text-xs text-gray-500 dark:text-gray-400">Admin</span>
        </div>
  
        <div class="p-4 space-y-4">
          <!-- Choose unit -->
          <div>
            <label class="block text-sm mb-1 text-slate-700 dark:text-slate-300">Unidade</label>
            <select v-model="unit"
                    class="w-full px-3 py-2 border rounded-md dark:bg-slate-800 dark:border-slate-700 dark:text-gray-100"
                    @change="loadList">
              <template v-if="
              (currentUser?.manager === 1 || currentUser?.manager === true) && 
              (currentUser?.admin === 0 || currentUser?.admin === false)">
              
                <option :value="currentUser.unit.toLowerCase()">
                  {{ currentUser.unit.toUpperCase() }}
                </option>
              </template>
              <template v-else>
                <option disabled value="">Selecione…</option>
                <option value="geaal">GEAAL</option>
                <option value="geof">GEOF</option>
                <option value="gpi">GPI</option>
                <option value="sgi">SGI</option>
              </template>        
            </select>
          </div>
  
          <!-- Add activity -->
           <div v-if="unit === 'geof'" class="space-y-2">
            <label class="block text-sm mb-1 text-slate-700 dark:text-slate-300">Processo *</label>
            <select v-model="selectedProcess"
                    class="w-full px-3 py-2 border rounded-md dark:bg-slate-800 dark:border-slate-700">
              <option disabled value="">Selecione o processo…</option>
              <option v-for="p in processos_GEOF" :key="p.id" :value="p.id">
                {{ p.label }}
              </option>
            </select>
          </div>

          <div class="flex gap-2">
            <input v-model.trim="newDispatch" placeholder="Nova atividade"
                   class="flex-1 px-3 py-2 border rounded-md dark:bg-slate-800 dark:border-slate-700 dark:text-gray-100"/>
            <input v-model.trim="newSubmission" placeholder="Nova entrega"
                   class="flex-1 px-3 py-2 border rounded-md dark:bg-slate-800 dark:border-slate-700 dark:text-gray-100"/>
            
            <div v-if="unit === 'geof'">
              <select v-model="newComplexity"
                    class="w-full px-3 py-2 border rounded-md dark:bg-slate-800 dark:border-slate-700">
              <option disabled value="">Complexidade da entrega...</option>
              <option v-for="p in weight_complexity_GEOF" :key="p.complexity" :value="p.complexity">
                {{ p.complexity }}
              </option>
            </select>
            </div>
            <fwb-button gradient="green-blue" outline :disabled="isAddDisabled" @click="unit === 'geof' ? addDispatchGEOF() : addDispatch()">
              Adicionar
            </fwb-button>
          </div>

          <div v-if="unit === 'geof'" class="flex gap-2">
            <input v-model.trim="newTask" placeholder="Nova tarefa"
                  class="flex-1 px-3 py-2 border rounded-md dark:bg-slate-800 dark:border-slate-700 dark:text-gray-100"/>
            <fwb-button gradient="green-blue" outline :disabled="!unit || !newTask" @click="addTaskGEOF()">
              Adicionar
            </fwb-button>
          </div>

          <!-- Available complexity and weight-->
          <div v-if="unit === 'geof'" class="space-y-2">
            <label class="block text-sm mb-1 text-slate-700 dark:text-slate-300">
              Complexidade *
            </label>
            <div class="flex gap-2">
              <input v-model.trim="addedComplexity" 
                placeholder="Nova complexidade"
                class="flex-1 px-3 py-2 border rounded-md dark:bg-slate-800 dark:border-slate-700 dark:text-gray-100"/>
              <input 
                v-model.number="addedWeight" 
                placeholder="Novo peso" 
                type="number" 
                min="1" step="1"
                class="flex-1 px-3 py-2 border rounded-md dark:bg-slate-800 dark:border-slate-700 dark:text-gray-100"/>
              <fwb-button gradient="green-blue" outline 
              :disabled="!addedComplexity || !addedWeight || currentUser.admin === 0 || currentUser.admin === false" 
              @click="addComplexityGEOF()">
                Adicionar
              </fwb-button>
            </div>
            
          </div>
          <div v-if="unit === 'geof'">
            <div class="border dark:border-slate-700 rounded-lg text-slate-900 dark:text-slate-100">
              <table class="min-w-full text-sm">
                <thead class="text-left bg-gray-50 dark:bg-slate-700/60">
                  <tr>
                    <th class="px-3 py-2">Complexidade</th>
                    <th class="px-3 py-2 w-20">Peso</th>
                    <th class="px-3 py-2 w-24"></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="c in weight_complexity_GEOF" :key="c.complexity"
                      class="border-b dark:border-slate-700 last:border-0 hover:bg-gray-50 dark:hover:bg-slate-700/50">
                    <td class="px-3 py-2">{{ c.complexity }}</td>
                    <td class="px-3 py-2">{{ c.weight }}</td>
                    <td class="px-3 py-2 text-right">
                      <button class="px-2 py-1 text-red-600 dark:text-red-400 hover:underline hover:text-red-700 dark:hover:text-red-300 
                      disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:no-underline"
                              :disabled="currentUser.admin === 0 || currentUser.admin === false" 
                              @click="removeComplexityGEOF(c.complexity)">Excluir</button>
                    </td>
                  </tr>
                  <tr v-if="!geof_rows.length">
                    <td class="px-3 py-6 text-center text-gray-500" colspan="3">Sem complexidades.</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <!-- List -->
          <div v-if="unit === 'geof'">
            <div class="border dark:border-slate-700 rounded-lg text-slate-900 dark:text-slate-100">
              <table class="min-w-full text-sm">
                <thead class="text-left bg-gray-50 dark:bg-slate-700/60">
                  <tr>
                    <th class="px-3 py-2 w-20">ID</th>
                    <th class="px-3 py-2">Processo</th>
                    <th class="px-3 py-2">Atividade</th>
                    <th class="px-3 py-2">Entrega</th>
                    <th class="px-3 py-2">Tarefa</th>
                    <th class="px-3 py-2">Complexidade</th>
                    <th class="px-3 py-2 w-24"></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="row in geof_rows" :key="row.id"
                      class="border-b dark:border-slate-700 last:border-0 hover:bg-gray-50 dark:hover:bg-slate-700/50">
                    <td class="px-3 py-2">{{ row.id }}</td>
                    <td class="px-3 py-2">{{ row.processo }}</td>
                    <td class="px-3 py-2">{{ row.entrega }}</td>
                    <td class="px-3 py-2">{{ row.submission }}</td>
                    <td class="px-3 py-2">{{ row.tarefa }}</td>
                    <td class="px-3 py-2">{{ row.complexity }}</td>
                    <td class="px-3 py-2 text-right">
                      <button class="px-2 py-1 text-red-600  dark:text-red-400 hover:underline hover:text-red-700 dark:hover:text-red-300"
                              @click="confirmDelete(row.id)">Excluir</button>
                    </td>
                  </tr>
                  <tr v-if="!geof_rows.length">
                    <td class="px-3 py-6 text-center text-gray-500" colspan="3">Sem entregas.</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div v-else>
            <div class="border dark:border-slate-700 rounded-lg text-slate-900 dark:text-slate-100">
            <table class="min-w-full text-sm">
              <thead class="text-left bg-gray-50 dark:bg-slate-700/60">
                <tr>
                  <th class="px-3 py-2 w-20">ID</th>
                  <th class="px-3 py-2">Entrega</th>
                  <th class="px-3 py-2 w-24"></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="row in rows" :key="row.id"
                    class="border-b dark:border-slate-700 last:border-0 hover:bg-gray-50 dark:hover:bg-slate-700/50">
                  <td class="px-3 py-2">{{ row.id }}</td>
                  <td class="px-3 py-2">{{ row.entrega }}</td>
                  <td class="px-3 py-2 text-right">
                    <button class="px-2 py-1 text-red-600 hover:underline"
                            @click="confirmDelete(row.id)">Excluir</button>
                  </td>
                </tr>
                <tr v-if="!rows.length">
                  <td class="px-3 py-6 text-center text-gray-500" colspan="3">Sem entregas.</td>
                </tr>
              </tbody>
            </table>
          </div>
          </div>

          <!-- Toasts -->
          <div class="fixed top-4 right-4 z-50 space-y-2">
            <fwb-toast v-if="toast.ok" type="success">Salvo.</fwb-toast>
            <fwb-toast v-if="toast.err" type="danger">{{ toast.msg }}</fwb-toast>
          </div>
        </div>
      </div>
    </div>
    <!-- Modal de exclusão do item-->
    <div v-if="showDeleteModal" class="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
      <div class="bg-white dark:bg-slate-800 rounded-lg shadow-lg p-6 w-96">
        <h3 class="text-lg font-semibold mb-2">
          Confirmar exclusão
        </h3>

        <p class="text-sm text-gray-600 dark:text-gray-300 mb-4">
          Tem certeza que deseja remover esta entrega/tarefa?
        </p>

        <div class="flex justify-end gap-2">
          <button
            class="px-4 py-2 bg-gray-200 rounded hover:bg-gray-300"
            @click="showDeleteModal = false">
            Cancelar
          </button>

          <button
            class="px-4 py-2 bg-red-600 text-white rounded hover:bg-red-700"
            @click="deleteConfirmed">
            Excluir
          </button>
        </div>
      </div>

    </div>
  </template>
  
  <script>
  import axios from 'axios'
  import { FwbButton, FwbToast } from 'flowbite-vue'
  import AppHeader from './Header.vue'
  import { processos_GEOF, hierarquia_GEOF, weight_complexity_GEOF } from "./GEOF";
  
  export default {
    name: 'AdminActivities',
    components: { FwbButton, FwbToast, AppHeader },
    data() {
      const isLocal = ['localhost', '127.0.0.1'].includes(window.location.hostname)
      return {
        unit: '',
        newDispatch: '',
        newSubmission: '',
        newComplexity: '',
        newTask: '',
        addedComplexity: '',
        addedWeight: null,
        rows: [],
        geof_rows: [],
        toast: { ok: false, err: false, msg: '' },
        apiBase: isLocal ? 'http://localhost:5000' : '/api',
        processos_GEOF,
        hierarquia_GEOF,
        weight_complexity_GEOF, 
        showDeleteModal: false,
        deleteId: null,
        currentUser: null,
        selectedProcess: ''
      }
    },
    computed: {
    isAddDisabled() {
        if (!this.unit || !this.newDispatch || !this.newSubmission) return true
        if (this.unit === 'geof' && !this.newComplexity) return true
        return false
      }
    },
    created() {
  try {
    const raw = localStorage.getItem('user');
    if (raw) {
      const u = JSON.parse(raw);
      this.currentUser = u;
      if (u && (u.admin === 1 || u.admin === true || u.manager === 1 || u.manager === true)) {
        this.unit = (u.unit || '').toLowerCase();
        if (this.unit) this.loadList();
      }
    }
  } catch (e) {
    console.debug('admin preselect unit: parse error', e);
  }
},
    methods: {
      flattenGEOfHierarchy() {
        const rows = []

        this.hierarquia_GEOF.forEach(proc => {
          // entregas do processo
          proc.entrega?.forEach(a => {
            rows.push({
              id: a.id,
              entrega: a.label,
              processo: proc.label,
              tarefa: '',
              submission: a.submission,
              complexity: a.complexity
            })
          })

          // tarefas do processo
          proc.tarefa?.forEach(e => {
            rows.push({
              id: e.id,
              entrega: '',
              processo: proc.label,
              tarefa: e.label,
              submission: '',
              complexity: ''
            })
          })
        })

        return rows
      },
      async loadList() {
        if (!this.unit) { this.rows = []; return }
        try {
          const { data } = await axios.get(`${this.apiBase}/admin/unit-activities`, {
            params: { unit: this.unit },
            headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
          })
          this.rows = data
          this.geof_rows = this.flattenGEOfHierarchy()
        } catch (e) {
          this.err('Falha ao carregar.')
          console.error(e)
        }
      },
      async addDispatch() {
        try {
          await axios.post(`${this.apiBase}/admin/unit-activities`,
            { unit: this.unit, 
              atividade: this.newDispatch, 
              entrega: this.newSubmission, 
              complexidade: this.newComplexity },
            { headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } }
          )
          this.newDispatch = ''
          this.ok()
          this.loadList()
        } catch (e) {
          const msg = e?.response?.data?.error || 'Falha ao adicionar.'
          this.err(msg); console.error(e)
        }
      },
      async removeActivity(id) {
        try {
          await axios.delete(`${this.apiBase}/admin/unit-activities/${this.unit}/${id}`, {
            headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
          })
          this.ok()
          this.rows = this.rows.filter(r => r.id !== id)
        } catch (e) {
          this.err('Falha ao excluir.'); console.error(e)
        }
      },
      addDispatchGEOF() {
        if (!this.selectedProcess) {
          this.err('Selecione um processo.')
          return
        }

        if (!this.newDispatch.trim()) {
          this.err('Digite o nome da atividade.')
          return
        }

        if (!this.newSubmission.trim()) {
          this.err('Digite o nome da entrega.')
          return
        }

        if (!this.newComplexity.trim()) {
          this.err('Selecione a complexidade.')
          return
        }
        if (!this.weight_complexity_GEOF.some(c => c.complexity === this.newComplexity)) {
          this.err('Complexidade não estabelecida previamente')
          return
        }
        const id = this.newDispatch
          .toLowerCase()
          .normalize("NFD").replace(/[\u0300-\u036f]/g, "")
          .replace(/\s+/g, "_")
          .replace(/[^\w]/g, "")

        const processoNode = this.hierarquia_GEOF.find(
          p => p.id === this.selectedProcess
        )

        if (!processoNode) {
          this.err('Processo não encontrado.')
          return
        }

        if (!processoNode.entrega)
          processoNode.entrega = []

        processoNode.entrega.push({
          id,
          label: this.newDispatch,
          submission: this.newSubmission,
          complexity: this.newComplexity
        })

        this.newDispatch = ''
        this.newSubmission = ''
        this.newComplexity = ''
        this.selectedProcess = ''
        this.geof_rows = this.flattenGEOfHierarchy()

        this.ok()
      },
      addTaskGEOF() {
        if (!this.selectedProcess) {
          this.err('Selecione um processo.')
          return
        }

        if (!this.newTask.trim()) {
          this.err('Digite o nome da entrega.')
          return
        }

        // cria id automático
        const id = this.newTask
          .toLowerCase()
          .normalize("NFD").replace(/[\u0300-\u036f]/g, "")
          .replace(/\s+/g, "_")
          .replace(/[^\w]/g, "")

        // encontra processo
        const processoNode = this.hierarquia_GEOF.find(
          p => p.id === this.selectedProcess
        )

        if (!processoNode) {
          this.err('Processo não encontrado.')
          return
        }

        // garante array tarefa
        if (!processoNode.tarefa)
          processoNode.tarefa = []

        // verifica duplicidade
        if (processoNode.tarefa.some(e => e.id === id)) {
          this.err('Tarefa já existe neste processo.')
          return
        }

        // adiciona tarefa
        processoNode.tarefa.push({
          id,
          label: this.newTask
        })

        // limpa campos
        this.newTask = ''
        this.selectedProcess = ''

        // atualiza visual
        this.geof_rows = this.flattenGEOfHierarchy()

        this.ok()
      },

      addComplexityGEOF() {
        
        if (!this.addedComplexity.trim()) {
          this.err('Digite o nome da complexidade.')
          return
        }

        if (!this.addedWeight) {
          this.err('Digite o peso da atividade com essa complexidade.')
          return
        }
        
        const complexidadeNode = this.weight_complexity_GEOF.find(
          p => p.complexity === this.addedComplexity
        )

        if (complexidadeNode) {
          this.err('Complexidade já existente.')
          return
        }
        
        this.weight_complexity_GEOF.push({   
          complexity: this.addedComplexity,
          weight: Number(this.addedWeight)
        })

        this.addedComplexity = ''
        this.addedWeight = null

        this.ok()
      },

      removeFromHierarchy(id) {
        this.hierarquia_GEOF.forEach(proc => {
          proc.entrega = proc.entrega?.filter(a => a.id !== id) || []
          proc.tarefa = proc.tarefa?.filter(e => e.id !== id) || []
        })

        this.geof_rows = this.flattenGEOfHierarchy()
      },
      confirmDelete(id) {
        this.deleteId = id
        this.showDeleteModal = true
      },

      deleteConfirmed() {
        if (this.unit === 'geof') {
          this.removeFromHierarchy(this.deleteId)
        }
        else if (this.unit != 'geof') {
          this.removeActivity(this.deleteId)
        }
        this.showDeleteModal = false
        this.deleteId = null
      },
      removeComplexityGEOF(complexityName) {
        const index = this.weight_complexity_GEOF.findIndex(c => c.complexity === complexityName)
        if (index !== -1) {
          this.weight_complexity_GEOF.splice(index,1)
        }
      },
      ok() { this.toast.ok = true; setTimeout(() => (this.toast.ok = false), 1800) },
      err(m) { this.toast.msg = m; this.toast.err = true; setTimeout(() => (this.toast.err = false), 2200) },     
    },
  }
  </script>
